videojs.addLanguage('lv', {
  "Audio Player": "Audio atskaņotājs",
  "Video Player": "Video atskaņotājs",
  "Play": "Atskaņot",
  "Pause": "Pauzēt",
  "Replay": "Atkārtot",
  "Current Time": "Esošais laiks",
  "Duration": "Ilgums",
  "Remaining Time": "Atlikušais laiks",
  "Stream Type": "Straumes veids",
  "LIVE": "LIVE",
  "Seek to live, currently behind live": "Pāriet uz tiešraidi",
  "Seek to live, currently playing live": "Pāriet uz tiešraidi",
  "Loaded": "Ielādēts",
  "Progress": "Progress",
  "Progress Bar": "Progresa josla",
  "progress bar timing: currentTime={1} duration={2}": "{1} no {2}",
  "Fullscreen": "Pilnekrāna režīms",
  "Non-Fullscreen": "Iziet no pilnekrāna režīma",
  "Mute": "Izslēgt skaņu",
  "Unmute": "Ieslēgt skaņu",
  "Playback Rate": "Atskaņošanas ātrums",
  "Subtitles": "Subtitri",
  "subtitles off": "Izslēgt subtitrus",
  "Captions": "Paraksti",
  "captions off": "Izslēgt parakstus",
  "Chapters": "Temati",
  "Descriptions": "Apraksti",
  "descriptions off": "Izslēgt aprakstus",
  "Audio Track": "Audio celiņš",
  "Volume Level": "Skaļums",
  "You aborted the media playback": "Atskaņošana atcelta",
  "A network error caused the media download to fail part-way.": "Tīkla kļūdas dēļ, multivides lejupielāde neizdevās.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Neizdevās ielādēt multividi, iespējams severa, vai tīkla kļūmes dēļ, vai neatbalstīta formāta dēļ.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Atskaņošana tika pārtraukta tīkla kļūmes dēļ vai pārlūkprogrammas iespēju trūkuma dēļ.",
  "No compatible source was found for this media.": "Netika atrasts atbilstošs multivides avots.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Multividi nevar atskaņot, jo tas ir kriptēts un nav pieejama dekriptēšanas atslēga.",
  "Play Video": "Atskaņot video",
  "Close": "Aizvērt",
  "Close Modal Dialog": "Aizvērt logu",
  "Modal Window": "Logs",
  "This is a modal window": "Logs",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Šo logu var aizvērt, nospiežot uz aizvēršanas pogas vai taustiņa ESC.",
  ", opens captions settings dialog": ", atvērs parakstu logu",
  ", opens subtitles settings dialog": ", atvērs subtitru logu",
  ", opens descriptions settings dialog": ", atvērs aprakstu logu",
  ", selected": ", izvēlēts",
  "captions settings": "parakstu iestatījumi",
  "subtitles settings": "subtitru iestatījumi",
  "descriptions settings": "aprakstu iestatījumi",
  "Text": "Teksts",
  "White": "Balts",
  "Black": "Melns",
  "Red": "Sarkans",
  "Green": "Zaļš",
  "Blue": "Zils",
  "Yellow": "Dzeltens",
  "Magenta": "Purpursarkana",
  "Cyan": "Ciāna",
  "Background": "Fons",
  "Window": "Logs",
  "Transparent": "Caurspīdīgs",
  "Semi-Transparent": "Daļēji caurspīdīgs",
  "Opaque": "Necaurspīdīgs",
  "Font Size": "Šrifta izmērs",
  "Text Edge Style": "Teksta ēnas stils",
  "None": "Neviens",
  "Raised": "Izvirzīts",
  "Depressed": "Samazināts",
  "Uniform": "Vienmērīgs",
  "Dropshadow": "Ēnots",
  "Font Family": "Šrifts",
  "Proportional Sans-Serif": "Proportional Sans-Serif",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Serif": "Proportional Serif",
  "Monospace Serif": "Monospace Serif",
  "Casual": "Casual",
  "Script": "Script",
  "Small Caps": "Small Caps",
  "Reset": "Atiestatīt",
  "restore all settings to the default values": "atiestatīt iestatījumu uz noklusējumu",
  "Done": "Gatavs",
  "Caption Settings Dialog": "Parakstu iestatījumi",
  "Beginning of dialog window. Escape will cancel and close the window.": "Paraksta iestatījumu sākums. Lai aizvērtu, spiediet ESC taustiņu.",
  "End of dialog window.": "Parakstu iestatījumu loga beigas",
  "{1} is loading.": "{1} ielādē.",
  "Exit Picture-in-Picture": "Iziet no Attēls attēlā",
  "Picture-in-Picture": "Attēls attēlā"
});